import { ControlFacet } from '../models/controls/ControlFacet';
import { IEngagementData } from '../facets/LoggerFacets';
import { graftControlOption } from '../models/controls/graftControlOption';

/**
 * @public
 */
export const itemEngagementControl: ControlFacet<{
  itemKey: string | undefined;
}, {
    engagement: Partial<IEngagementData>;
  }> = new ControlFacet('itemEngagement', {
    engagement: graftControlOption<Partial<IEngagementData>>()
  });
